import siteInfo from "@/constants/siteInfo";
import dynamic from "next/dynamic";
//import Link from "next/link";
import { useRouter } from "next/router";
import { useContext, useState } from "react";
import SVG from "react-inlinesvg";
import { useEffect } from "react";
import sendGAEvent from "@/utils/gaEvent";
import NavLink from "../Navlink";
import { useAuth } from "@/context/AuthContext";
import { getDashboardUrl } from "@/utils/sso";
import { MasterConfigContext } from "@/context/MasterConfigContext";

const MobileMenuSlider = dynamic(() => import("./MobileMenuSlider"));

const MobileNavbar = ({ header_menu = [] }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [isSearchBoxOpen, setIsSearchBoxOpen] = useState(false);
  const [IsSubCategOpen, setIsSubCategOpen] = useState(false);
  const { user, login, logout, isAuthenticated } = useAuth();
  const router = useRouter();
  const isRajasthan = router?.asPath?.includes("/rajasthan");
  const isMadhya = router?.asPath?.includes("/madhya-pradesh");
  const isHR = router?.asPath?.includes("/haryana");
  const isBH = router?.asPath?.includes("/bihar");
  const isUP =
    router?.asPath?.includes("/uttar-pradesh") &&
    !router.asPath.includes("board-results");
  const isDL = router?.asPath?.includes("/delhi");
  const isCGH = router?.asPath?.includes("/chhattisgarh");
  const isUK = router?.asPath?.includes("/uttarakhand");
  const isBiz = router?.asPath?.includes("/business");
  const isPB = router?.asPath?.includes("/punjab");
  const websiteUrl = process.env.NEXT_PUBLIC_WEBSITE_URL;
  const masterConfig = useContext(MasterConfigContext);
  const ssoKeys = masterConfig["SSO"];
  const liveKeys = masterConfig["livetv_page"];

  const handleSearch = () => {
    if (!searchText?.trim()?.length > 0) return;
    setIsDrawerOpen(false);
    setSearchText("");
    setIsSearchBoxOpen(false);
    let eventName = `view_search_results`;
    sendGAEvent({
      eventName: eventName,
      pageTitle: document?.title,
      pageLocation: window?.location?.href,
      searchQuery: searchText?.trim(),
    });
    window.location.href = `${process.env.NEXT_PUBLIC_WEBSITE_URL
      }/search/${encodeURIComponent(searchText?.trim())}`;
    // setSearchText("");
  };
  const handleKeyPress = (event) => {
    if (event.key === "Enter" && searchText?.trim()?.length > 0) {
      setIsDrawerOpen(false);
      handleSearch();
      // Blur the input field to close the keyboard
      event.target.blur();
    }
  };

  useEffect(() => {
    if (isDrawerOpen) {
      // Prevent scrolling
      document.body.style.overflow = "hidden";
      let element = document.querySelectorAll(".vdo_floating");
      let element2 = document.querySelectorAll("#vdo_logo_parent");

      for (var i = 0; i < element.length; i++) {
        element[i].style.setProperty("z-index", "0", "important");
      }
      for (var i = 0; i < element2.length; i++) {
        element2[i].style.setProperty("display", "none", "important");
      }
    } else {
      // Re-enable scrolling
      document.body.style.overflow = "";
      let element = document.querySelectorAll(".vdo_floating");
      let element2 = document.querySelectorAll("#vdo_logo_parent");

      for (var i = 0; i < element.length; i++) {
        element[i].style.setProperty("z-index", "1", "important");
      }
      for (var i = 0; i < element2.length; i++) {
        element2[i].style.setProperty("display", "block", "important");
      }
    }

    // Cleanup function to re-enable scrolling when the component unmounts
    return () => {
      document.body.style.overflow = "";
    };
  }, [isDrawerOpen]);
  // console.log(websiteUrl+(isMadhya?'/madhya-pradesh':isRajasthan?'/rajasthan':isUP?'/uttar-pradesh':isHR?'/haryana':isBH?'/bihar':isDL?'/delhi-news':'/'))
  return (
    <>
      <nav className={`w-full  top-0 z-50 bg-white shadow-md `}>
        <div className=" flex items-center justify-between px-2 py-1">
          <div className="flex items-center">
            <button
              className="min-w-[35px] text-gray-500 focus:outline-none"
              onClick={() => {
                let eventName = `TopBar-HamburgerMenu`;
                sendGAEvent({
                  eventName: eventName,
                  pageTitle: document?.title,
                  pageLocation: window?.location?.href,
                });
                setIsDrawerOpen(!isDrawerOpen);
              }}
            >
              <img
                className="min-w-[35px]"
                src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/menu.svg"
                alt="menu icon"
                width={35}
                height={35}
                loading="eager"
              />
            </button>
            <div className="ml-2">
              <a
                href={
                  websiteUrl +
                  (isMadhya
                    ? "/madhya-pradesh"
                    : isRajasthan
                      ? "/rajasthan"
                      : isUP
                        ? "/uttar-pradesh"
                        : isHR
                          ? "/haryana"
                          : isBH
                            ? "/bihar"
                            : isDL
                              ? "/delhi-news"
                              : isCGH
                                ? "/chhattisgarh"
                                : isUK
                                  ? "/uttarakhand"
                                  : isBiz
                                    ? "/business"
                                    : isPB
                                      ? "/punjab"
                                      : "/")
                }
                onClick={() => {
                  let eventName = `TopBar-LogoClick`;
                  sendGAEvent({
                    eventName: eventName,
                    pageTitle: document?.title,
                    pageLocation: window?.location?.href,
                  });
                  setIsDrawerOpen(false);
                }}
              >
                <img
                  src={
                    isDrawerOpen
                      ? siteInfo?.siteLogo
                      : isRajasthan
                        ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/frame-2994.png"
                        : isMadhya
                          ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/frame-3068.png"
                          : isHR
                            ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/haryana_tak_light.png"
                            : isBH
                              ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/bihar_tak_light.png"
                              : isUP
                                ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/uptak_light.png"
                                : isDL
                                  ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/delhi_tak_light.png"
                                  : isCGH
                                    ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/ccg_logo.png"
                                    : isUK
                                      ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/ut-2.png"
                                      : isBiz
                                        ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/biz-horizontal.svg"
                                        : isPB
                                          ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/punjab-tak1-2.png"


                                          : siteInfo?.siteLogo
                  }
                  alt={
                    isMadhya
                      ? "MP Tak - Mobile"
                      : isRajasthan
                        ? "Rajasthan Tak - Mobile"
                        : isUP
                          ? "UP Tak - Mobile"
                          : isHR
                            ? "Haryana Tak - Mobile"
                            : isBH
                              ? "Bihar Tak - Mobile"
                              : isDL
                                ? "Delhi Tak - Mobile"
                                : isCGH
                                  ? "Chattisgarh Tak - Mobile"
                                  : isUK
                                    ? "Uttarakhand tak - Mobile"
                                    : isBiz
                                      ? "Business Tak - Mobile"
                                      : isPB
                                        ? "Punjab Tak - Mobile"
                                        : siteInfo?.siteName + " - Mobile"
                  }
                  title={
                    isMadhya
                      ? "MP Tak"
                      : isRajasthan
                        ? "Rajasthan Tak"
                        : isUP
                          ? "UP Tak"
                          : isHR
                            ? "Haryana Tak"
                            : isBH
                              ? "Bihar Tak"
                              : isDL
                                ? "Delhi Tak"
                                : isCGH
                                  ? "Chattisgarh Tak"
                                  : isUK
                                    ? "Uttarakhand Tak"
                                    : isBiz
                                      ? "Business Tak"
                                      : isPB
                                        ? "Punjab Tak"
                                        : siteInfo?.siteName
                  }
                  loading="eager"
                  fetchpriority="high"
                  height={isMadhya ? 30 : 37}
                  width={isUK ? 120 : 90}
                // className={`${isMadhya?' height-[30px] width-[auto]':'height-[35px]'}`}
                />
              </a>
            </div>
          </div>
          <div className="flex space-x-2 justify-end ml-auto">
            <NavLink
              exact={true}
              className={"text-primary"}
              href={liveKeys?.activeUrl || "/tak360-livetv"}
              title={""}
              onClick={() => {
                let eventName = `TopBar-ReadClick`;
                sendGAEvent({
                  eventName: eventName,
                  pageTitle: document?.title,
                  pageLocation: window?.location?.href,
                });
              }}
            >
              <SVG
                src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/Live-msite.svg"
                className=" mr-2"
                title="home"
              />
            </NavLink>
          </div>

          <div className="flex space-x-2 ml-2 max-w-[50%]">
            {/* Search Box */}
            <div className="flex items-center max-w-auto">
              {isSearchBoxOpen ? (
                <>
                  <div className="flex items-center">
                    <div className="relative">
                      <input
                        id="search"
                        className={` placeholder:italic placeholder:text-slate-400 block w-full bg-white border border-slate-300 rounded-md py-1 pl-3 pr-10 shadow-sm focus:outline-none focus:border-red-300 focus:ring-red-300 focus:ring-1 sm:text-sm max-h-[40px]`}
                        placeholder="यहां खोज करें"
                        type="text"
                        name="search"
                        minLength={1}
                        value={searchText}
                        onKeyDown={handleKeyPress}
                        onChange={(e) => setSearchText(e.target.value)}
                      />
                      <div
                        role="button"
                        className="absolute inset-y-0 right-0 flex items-center pr-3"
                        onClick={() => handleSearch()}
                      >
                        <img
                          className="text-gray-500"
                          loading="eager"
                          src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/search.svg"
                          alt="Search Icon"
                          height={20}
                          width={20}
                        />
                      </div>
                    </div>
                  </div>
                  <button
                    onClick={() => setIsSearchBoxOpen(false)}
                    className="focus:outline-none rounded-sm p-1"
                  >
                    <span className="h-6 w-6 text-black">
                      <SVG src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/close.svg" />
                    </span>
                  </button>
                </>
              ) : (
                <button className="text-gray-700 focus:outline-none mr-4 md:hidden">
                  <img
                    loading="eager"
                    height={24}
                    width={24}
                    src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/search.svg"
                    alt="Search Icon"
                    onClick={() => {
                      let eventName = `TopBar-Search`;
                      sendGAEvent({
                        eventName: eventName,
                        pageTitle: document?.title,
                        pageLocation: window?.location?.href,
                      });
                      setIsSearchBoxOpen(true);
                    }}
                  />
                </button>
              )}
            </div>
          </div>
        </div>
        <MobileMenuSlider header_menu={header_menu} />
      </nav>
      {/* Drawer overlay */}
      <div
        className={`fixed inset-0 bg-black bg-opacity-50 z-50 transition-opacity ${isDrawerOpen ? "opacity-100" : "opacity-0 pointer-events-none"
          }`}
        onClick={() => setIsDrawerOpen(false)}
      ></div>

      {/* Drawer menu */}
      <section >
        <div
          className={`fixed left-0 transform w-screen text-slate-700 shadow-xl bg-white transition-transform ${isDrawerOpen ? "translate-x-0" : "-translate-x-full"
            }`}
          style={{ zIndex: 101, top: 0, bottom: 120, overflowY: "auto" }}
        >
          <div
            className={`flex flex-col ${isMadhya
              ? "bg-[#0C8A70]"
              : isRajasthan
                ? "bg-[#FFA51A]"
                : isHR
                  ? "bg-[#EFF8EC]"
                  : isBH
                    ? "bg-[#FAEDF5]"
                    : isUP
                      ? "bg-[#feedeb]"
                      : isDL
                        ? "bg-[#fbd6d6]"
                        : isCGH
                          ? "bg-[#0C8A70]"
                          : isUK
                            ? "bg-[#05a1fa]"
                            : isBiz ? "bg-bizDark"
                              : isPB ? "bg-pbDark"
                                : "bg-primary"
              }`}
          >
            <div className="flex items-center justify-between">
              <div className="ml-2">
                <a
                  href={
                    websiteUrl +
                    (isMadhya
                      ? "/madhya-pradesh"
                      : isRajasthan
                        ? "/rajasthan"
                        : isUP
                          ? "/uttar-pradesh"
                          : isHR
                            ? "/haryana"
                            : isBH
                              ? "/bihar"
                              : isDL
                                ? "/delhi-news"
                                : isCGH
                                  ? "/chhattisgarh"
                                  : isUK
                                    ? "/uttarakhand"
                                    : isBiz
                                      ? "/business"
                                      : isPB
                                        ? "/punjab"
                                        : "/")
                  }
                  onClick={() => setIsDrawerOpen(false)}
                >
                  {isBiz ? <div className="ps-4 pt-2">  <svg xmlns="http://www.w3.org/2000/svg" width="106" height="33" viewBox="0 0 106 33" fill="none">
                    <path d="M105.925 19.6218C105.926 17.8003 105.53 16.0003 104.764 14.3475C103.998 12.6948 102.881 11.229 101.491 10.0524C100.1 8.87568 98.4701 8.0165 96.7135 7.53468C94.957 7.05286 93.1166 6.95997 91.3205 7.26257C90.2872 5.60313 88.922 4.17523 87.3107 3.06856C85.6994 1.96189 83.8767 1.20039 81.957 0.831752C80.0374 0.463111 78.0623 0.495327 76.1557 0.926428C74.2491 1.35753 72.4523 2.17816 70.8779 3.33684C68.853 1.77802 66.4858 0.72451 63.9724 0.263611C61.459 -0.197288 58.8719 -0.0522867 56.4258 0.686654C53.9796 1.42559 51.7449 2.73716 49.9069 4.51254C48.0689 6.28792 46.6807 8.47595 45.8573 10.8952C45.0339 13.3144 44.7992 15.8951 45.1724 18.4232C45.5457 20.9513 46.5163 23.354 48.0037 25.432C49.4911 27.51 51.4524 29.2034 53.7251 30.3717C55.9977 31.5401 58.5161 32.1497 61.0714 32.15C61.1703 32.15 61.2676 32.15 61.3649 32.15H61.4383H93.4538C96.7669 32.1338 99.9387 30.8061 102.276 28.4574C104.613 26.1087 105.925 22.9301 105.925 19.6167" fill="white" />
                    <path d="M68.3135 8.74402V12.325H63.2567V28.2295H58.7288V12.325H53.7266V8.74402H68.3135Z" fill="#3A98D4" />
                    <path d="M74.5528 14.1155C75.347 14.6111 75.9715 15.3368 76.3431 16.1962V13.5369H80.818V28.2313H76.3516V25.5754C75.981 26.4353 75.3563 27.1613 74.5613 27.6561C73.6877 28.1844 72.6804 28.4499 71.6599 28.4207C70.5105 28.4379 69.3807 28.122 68.407 27.511C67.4189 26.8706 66.6338 25.9618 66.1439 24.891C65.5898 23.7531 65.3128 22.4188 65.3128 20.8884C65.3128 19.3579 65.5898 18.0197 66.1439 16.8738C66.6365 15.8079 67.4212 14.9037 68.407 14.2658C69.3809 13.6554 70.5107 13.3399 71.6599 13.3577C72.6802 13.3287 73.6872 13.5936 74.5613 14.1207L74.5528 14.1155ZM70.7827 18.2546C70.1933 18.8885 69.8992 19.7664 69.9003 20.8884C69.9015 22.0103 70.1956 22.8883 70.7827 23.5221C71.3698 24.1536 72.1463 24.4694 73.1123 24.4694C73.5476 24.4834 73.9809 24.4038 74.3828 24.2359C74.7847 24.0681 75.1459 23.8159 75.4419 23.4964C76.0484 22.8455 76.3516 21.9762 76.3516 20.8884C76.3516 19.7823 76.0484 18.909 75.4419 18.2683C75.1436 17.9525 74.7818 17.7036 74.3802 17.538C73.9786 17.3723 73.5465 17.2937 73.1123 17.3074C72.1463 17.3074 71.3698 17.6231 70.7827 18.2546Z" fill="#3A98D4" />
                    <path d="M91.7718 28.2295L87.3754 21.9893V28.2295H82.8732V8.74402H87.3754V19.4341L91.9032 13.5352H97.1956L91.1403 20.8832L97.1956 28.2295H91.7718Z" fill="#3A98D4" />
                    <path d="M0.0128703 8.84148C0.794655 8.69542 1.58517 8.60066 2.37933 8.55787C3.38984 8.48912 4.42097 8.45391 5.47272 8.45219C6.56002 8.43403 7.64683 8.51084 8.72078 8.68167C9.52851 8.81943 10.3054 9.09963 11.0151 9.50923C11.6671 9.85848 12.2244 10.361 12.6391 10.9736C13.0704 11.6264 13.2917 12.3956 13.2732 13.1778C13.2728 14.012 13.0074 14.8245 12.5153 15.4981C11.9197 16.2811 11.101 16.8653 10.1669 17.1739V17.2435C11.1977 17.5186 12.1286 18.0821 12.8505 18.8677C13.5754 19.694 13.9547 20.7676 13.9099 21.8659C13.9242 22.6504 13.7416 23.426 13.3789 24.1218C13.0303 24.778 12.5503 25.3555 11.9688 25.8182C11.136 26.4279 10.1865 26.8596 9.17964 27.0866C7.6738 27.4267 6.13189 27.5809 4.58851 27.5455C3.52903 27.5455 2.61906 27.5171 1.85344 27.4552C1.08783 27.3933 0.469165 27.334 0 27.2644L0.0128703 8.84148ZM4.21474 16.0008H5.59129C6.72038 16.0008 7.57366 15.7894 8.15109 15.3666C8.42172 15.1841 8.64244 14.9369 8.79325 14.6474C8.94406 14.3579 9.02018 14.0353 9.01465 13.7089C9.01465 12.2497 8.01445 11.5209 6.01406 11.5227C5.54232 11.5227 5.17367 11.5227 4.903 11.5562C4.6712 11.5737 4.44112 11.6091 4.21474 11.6619V16.0008ZM4.21474 24.328C4.44855 24.3519 4.68347 24.363 4.91848 24.3615H5.83875C6.30721 24.364 6.77464 24.3173 7.23337 24.2223C7.64052 24.1391 8.02918 23.9828 8.38049 23.7609C8.70826 23.5534 8.98074 23.2693 9.17448 22.9332C9.38416 22.5498 9.48741 22.1172 9.47352 21.6803C9.47352 20.7196 9.10315 20.0381 8.36246 19.6359C7.52594 19.214 6.59737 19.0075 5.6609 19.0352H4.21474V24.328Z" fill="white" />
                    <path d="M20.914 8.59144H16.6426V27.3235H20.914V8.59144Z" fill="white" />
                    <path d="M23.4198 25.0317L32.352 12.1904V12.0847H24.2679V8.59144H37.8582V11.0251L29.1374 23.7272V23.8303H38V27.3235H23.4198V25.0317Z" fill="white" />
                  </svg></div>
                    : isPB ? <svg width="140" height="60" viewBox="0 0 165 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M14.6196 19.7359L14.6479 19.759L17.1242 18.8642L17.1858 18.8411L17.1601 18.7796C17.0704 18.5642 16.9858 18.3361 16.9037 18.1079C16.7951 17.7848 16.7389 17.4463 16.7371 17.1054C16.7198 16.7905 16.7663 16.4754 16.8738 16.1789C16.9813 15.8824 17.1475 15.6106 17.3626 15.38C17.568 15.1746 17.813 15.0133 18.0827 14.9057C18.3524 14.7982 18.6413 14.7467 18.9316 14.7544C19.2237 14.7424 19.5151 14.7898 19.7883 14.8938C20.0615 14.9978 20.3108 15.1562 20.521 15.3595C20.9209 15.762 21.1259 16.3491 21.1259 17.1054C21.1281 17.4544 21.0709 17.8012 20.9567 18.1309C20.8824 18.3489 20.7978 18.5642 20.7004 18.777L20.6748 18.8411L23.223 19.7487H23.2537L23.2819 19.7282C23.6724 19.4153 23.9973 19.0285 24.2381 18.5899C24.5562 18.0266 24.7174 17.3882 24.7047 16.7414C24.7129 16.0548 24.5517 15.3768 24.2355 14.7673C23.9211 14.1739 23.4894 13.6505 22.9666 13.229C22.4177 12.7895 21.793 12.4541 21.1234 12.2393C19.6981 11.7928 18.1721 11.7803 16.7397 12.2035C16.0809 12.393 15.4622 12.7014 14.9144 13.1136C14.3881 13.517 13.9574 14.0318 13.6532 14.6211C13.3302 15.2641 13.1683 15.9759 13.1815 16.6953C13.1609 17.3774 13.339 18.0507 13.6942 18.6334C13.9408 19.0427 14.2525 19.409 14.6171 19.7179" fill="#252525" />
                      <path d="M16.9296 21.4998V35.9391L16.8527 35.998C15.7972 36.7707 14.5629 37.2628 13.2653 37.4283C11.9678 37.5938 10.6494 37.4272 9.43383 36.9441C8.62985 36.6306 7.94168 36.0774 7.46249 35.3597L7.40096 35.2648L7.45736 35.1648C7.99598 34.1893 8.42582 33.1576 8.73912 32.0883C9.05627 30.9683 9.21251 29.809 9.20314 28.6451C9.20459 27.8718 9.13941 27.0998 9.00831 26.3377C8.89121 25.6485 8.72933 24.9676 8.52376 24.2995C8.34683 23.7258 8.13977 23.1618 7.90341 22.6099C7.71371 22.1792 7.53681 21.81 7.3753 21.5203L7.35734 21.487H0V24.8071H4.4708L4.51185 24.9481C4.77767 26.0715 4.89826 27.2243 4.87072 28.3784C4.87072 30.8192 4.16063 33.2497 2.75837 35.5802L2.74041 35.6109L2.75837 35.6443C3.63852 37.2624 4.95593 38.6003 6.56012 39.5054C8.2643 40.4159 10.1732 40.8749 12.105 40.8385C12.9939 40.8546 13.8812 40.7572 14.7455 40.5488C15.4047 40.3833 16.0435 40.1451 16.6502 39.8386L16.9322 39.6925V44.4125H21.262V24.8071H41.1679V31.6729H32.6159V29.0963L32.5903 29.0758C32.3342 28.8973 32.05 28.763 31.7494 28.6784C30.6815 28.3991 29.5558 28.4329 28.5065 28.7758C27.963 28.9583 27.4581 29.24 27.0172 29.6065C26.591 29.9589 26.242 30.3953 25.9917 30.8884C25.7403 31.392 25.6128 31.9485 25.62 32.5113C25.6092 32.9014 25.69 33.2887 25.8559 33.6419C26.0018 33.9455 26.2006 34.2207 26.4429 34.4546C26.6725 34.6713 26.939 34.8449 27.2299 34.9674C27.5202 35.0863 27.8228 35.1723 28.1323 35.2238L28.2912 35.252V44.415H32.6236V35.0623H41.1756V44.4125H45.5079V24.8071H51.1938V35.534H55.5263V24.8071H60.0714L60.1047 24.9558C60.4256 26.2961 61.0325 27.5512 61.8839 28.6349C62.7352 29.7187 63.8108 30.6055 65.037 31.2345L65.3985 31.4217L65.0216 31.5806C63.8136 32.0781 62.7242 32.8251 61.8248 33.7727C60.9677 34.675 60.2685 35.715 59.7561 36.8492L59.7407 36.88L59.7587 36.9082C60.7753 38.5395 62.2452 39.8394 63.9885 40.6488C65.8736 41.5335 67.9331 41.9838 70.0154 41.9666C71.6936 42.0025 73.3584 41.6599 74.8861 40.9642L75.1578 40.8308V44.4022H79.4902V24.8071H83.0022V21.4998H16.9296ZM70.5076 38.5901C69.3126 38.62 68.1239 38.4072 67.0134 37.9645C66.1453 37.6131 65.3519 37.0998 64.6755 36.4518L64.573 36.3493L64.6447 36.2237C65.2156 35.2213 66.0689 34.409 67.0981 33.888C68.185 33.3138 69.5821 33.0215 71.2535 33.0215H75.1373V37.3236L75.0527 37.38C74.4222 37.7863 73.7294 38.0868 73.0019 38.2696C72.1914 38.4844 71.3563 38.5921 70.5178 38.5901H70.5076ZM65.5035 26.7505C65.1808 26.222 64.9413 25.6469 64.7934 25.0455L64.737 24.8097H75.1476V29.7885H70.3999C69.7017 29.7958 69.0103 29.6496 68.3747 29.3604C67.7756 29.0819 67.2231 28.7127 66.7366 28.2656C66.2534 27.8239 65.8379 27.3134 65.5035 26.7505Z" fill="#252525" />
                      <path d="M163.731 34.5889C163.732 32.3118 163.237 30.0617 162.28 27.9956C161.323 25.9295 159.926 24.0972 158.188 22.6263C156.45 21.1554 154.412 20.0813 152.216 19.479C150.02 18.8767 147.72 18.7606 145.475 19.1388C144.183 17.0644 142.476 15.2794 140.462 13.896C138.448 12.5126 136.169 11.5606 133.769 11.0998C131.37 10.639 128.901 10.6793 126.517 11.2182C124.134 11.7571 121.888 12.7829 119.92 14.2314C117.388 12.2827 114.429 10.9658 111.287 10.3896C108.145 9.81343 104.911 9.9947 101.853 10.9184C98.7956 11.8422 96.002 13.4817 93.7043 15.7011C91.4067 17.9204 89.6713 20.6557 88.642 23.6799C87.6127 26.7041 87.3192 29.9301 87.7859 33.0905C88.2525 36.2508 89.4658 39.2544 91.3252 41.852C93.1845 44.4497 95.6364 46.5666 98.4773 48.0271C101.318 49.4876 104.466 50.2496 107.661 50.2501C107.784 50.2501 107.906 50.2501 108.028 50.2501H108.119H148.141C152.283 50.2297 156.248 48.57 159.169 45.634C162.091 42.6979 163.731 38.7244 163.731 34.5824" fill="white" />
                      <path d="M116.719 20.9907V25.4672H110.398V45.3491H104.738V25.4672H98.4844V20.9907H116.719Z" fill="#FED029" />
                      <path d="M124.519 27.7055C125.512 28.325 126.292 29.2322 126.757 30.3065V26.9822H132.351V45.3513H126.767V42.0313C126.304 43.1062 125.523 44.0138 124.529 44.6322C123.437 45.2928 122.178 45.6246 120.902 45.5881C119.466 45.6097 118.053 45.2147 116.836 44.4509C115.601 43.6503 114.619 42.5142 114.007 41.1757C113.314 39.7532 112.968 38.0853 112.968 36.1721C112.968 34.2589 113.314 32.586 114.007 31.1536C114.623 29.8212 115.604 28.6907 116.836 27.8933C118.054 27.1303 119.466 26.736 120.902 26.7581C122.178 26.722 123.437 27.0531 124.529 27.712L124.519 27.7055ZM119.806 32.8797C119.069 33.6721 118.701 34.7695 118.703 36.1721C118.704 37.5747 119.072 38.6721 119.806 39.4645C120.54 40.2539 121.511 40.6486 122.718 40.6486C123.262 40.6661 123.804 40.5666 124.306 40.3568C124.809 40.147 125.26 39.8317 125.63 39.4324C126.388 38.6187 126.767 37.532 126.767 36.1721C126.767 34.7895 126.388 33.6977 125.63 32.8968C125.257 32.5021 124.805 32.1909 124.303 31.9839C123.801 31.7768 123.261 31.6785 122.718 31.6956C121.511 31.6956 120.54 32.0903 119.806 32.8797Z" fill="#FED029" />
                      <path d="M146.044 45.3491L140.548 37.5483V45.3491H134.92V20.9907H140.548V34.3541L146.208 26.9801H152.824L145.254 36.1657L152.824 45.3491H146.044Z" fill="#FED029" />
                    </svg>


                      : <img
                        src={
                          isDrawerOpen
                            ? isRajasthan
                              ? "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/brand-logo-2_rjtak.png"
                              : isMadhya
                                ? "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/brand-logo-2-mp.png"
                                : isHR
                                  ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/haryana_tak_light.png"
                                  : isBH
                                    ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/bihar_tak_light.png"
                                    : isUP
                                      ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/uptak_light.png"
                                      : isDL
                                        ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/delhi_tak_light.png"
                                        : isCGH
                                          ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/cgh_mobile_logo.png" //change
                                          : isUK
                                            ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/ut-2.png"

                                            :   siteInfo?.siteLogo2
                            : isRajasthan
                              ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/frame-2994.png"
                              : isMadhya
                                ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/frame-3068.png"
                                : isHR
                                  ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/haryana_tak_light.png"
                                  : isBH
                                    ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/bihar_tak_light.png"
                                    : isUP
                                      ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/uptak_light.png"
                                      : isDL
                                        ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/delhi_tak_light.png"
                                        : isCGH
                                          ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/ccg_logo.png"
                                          : isUK
                                            ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/ut-2.png"
                                            : isBiz ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/biz-horizontal.svg"
                                              : isPB ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/punjab-tak1-2.png"
                                                : siteInfo?.siteLogo
                        }
                        alt={
                          isMadhya
                            ? "MP Tak"
                            : isRajasthan
                              ? "Rajasthan Tak"
                              : isUP
                                ? "UP Tak"
                                : isHR
                                  ? "Haryana Tak"
                                  : isBH
                                    ? "Bihar Tak"
                                    : isDL
                                      ? "Delhi Tak"
                                      : isCGH
                                        ? "Chhattisgarh Tak"
                                        : isUK
                                          ? "Uttarakhand Tak"
                                          : isBiz ? "Biz Tak"
                                            : isPB ? "Punjab Tak"
                                              : siteInfo?.siteName
                        }
                        className="ps-4 pt-2"
                        title={
                          isMadhya
                            ? "MP Tak"
                            : isRajasthan
                              ? "Rajasthan Tak"
                              : isUP
                                ? "UP Tak"
                                : isHR
                                  ? "Haryana Tak"
                                  : isBH
                                    ? "Bihar Tak"
                                    : isDL
                                      ? "Delhi Tak"
                                      : isCGH
                                        ? "Chhattisgarh Tak"
                                        : isUK
                                          ? "Uttarakhand Tak"
                                          : isBiz ? "Biz Tak"
                                            : isPB ? "Punjab Tak"
                                              : siteInfo?.siteName
                        }
                        loading="eager"
                        height={40}
                        width={130}
                      />}
                </a>
              </div>

              <button
                onClick={() => setIsDrawerOpen(false)}
                className="focus:outline-none rounded-sm p-2"
              >
                <span
                  className={`h-6 w-6 ${isDL || isUP || isBH || isHR || isUK
                    ? "text-black"
                    : "text-white"
                    }`}
                >
                  <SVG src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/close.svg" />
                </span>
              </button>
            </div>
            {ssoKeys?.showSignInButton ? (
              <div
                className={`my-2 ml-3 p-2 ${isDL || isUP || isBH || isHR || isUK
                  ? "text-black"
                  : "text-white"
                  }`}
              >
                {!isAuthenticated && (
                  <div onClick={login} className="flex items-center gap-1">
                    <SVG
                      src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/user_ico.svg"
                      className="w-8 h-8"
                    />
                    <button className="border-b ">Sign In</button>
                  </div>
                )}
                {isAuthenticated && (
                  <div className="flex items-center gap-1">
                    {user?.photo && (
                      <img
                        src={user?.photo || "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/authorDefault.png"}
                        alt="user"
                        className="w-12 h-12 rounded-full border border-primary"
                      />
                    )}
                    {!user?.photo && (
                      <SVG
                        src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/user_ico.svg"
                        className="w-12 h-12"
                      />
                    )}
                    <div className="flex flex-col">
                      <a
                        href={getDashboardUrl(router?.asPath)}
                        className="font-semibold flex items-center gap-1"
                      >
                        {user?.givenName || "Guest"}
                        <SVG
                          src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/edit.svg"
                          className="w-4 h-4"
                        />
                      </a>
                      <span onClick={logout} className="border-b w-fit">
                        Sign Out
                      </span>
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <></>
            )}
          </div>

          <ul className="divide-y divide-gray-200 bg-white dark:divide-gray-800 rounded-t-xl pt-2 pb-6">
            <div className="flex my-2 mx-4 h-[40px]">
              <div className="flex items-center justify-center w-full">
                <div className="relative w-full">
                  <input
                    id="search"
                    className={` placeholder:italic placeholder:text-slate-400 block w-full bg-white border border-slate-300 rounded-md py-2 pl-3 pr-10 shadow-sm focus:outline-none focus:border-primary-300 focus:ring-primary-300 focus:ring-1 sm:text-sm max-h-[40px]`}
                    placeholder="यहां खोज करें"
                    type="text"
                    name="search"
                    value={searchText}
                    onKeyDown={handleKeyPress}
                    onChange={(e) => setSearchText(e.target.value)}
                  />
                  <div
                    className="absolute inset-y-0 right-0 flex items-center pr-3"
                    onClick={() => handleSearch()}
                  >
                    <img
                      className="text-gray-500"
                      loading="eager"
                      height={20}
                      width={20}
                      src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/search.svg"
                      alt="Search Icon"
                    />
                  </div>
                </div>
              </div>
            </div>
            {header_menu?.map((item, index) => (
              <li
                key={index}
                id={item?.id}
                // className="hover:bg-primary-300 group    "
                className={`${isMadhya
                  ? "hover:bg-[#e2f8f4] group"
                  : isRajasthan
                    ? "hover:bg-[#faf2e7] group"
                    : isHR
                      ? "hover:bg-[#e8fce1] group"
                      : isBH
                        ? "hover:bg-[#ffe2f4] group"
                        : isUP
                          ? "hover:bg-[#feedeb] group"
                          : isDL
                            ? "hover:bg-[#fbd6d6] group"
                            : isCGH
                              ? "hover:bg-[#e0faf5] group"
                              : isUK
                                ? "hover:bg-[#e2f1fa] group"
                                : isBiz ? "hover:bg-bizLight group"
                                  : isPB ? "hover:bg-pbLight group"
                                    : "hover:bg-primary-300 group"
                  }`}
                onClick={() => {
                  if (item?.sub_menu?.length > 0) {
                    setIsSubCategOpen(!IsSubCategOpen);
                  } else {
                    setIsDrawerOpen(false);
                  }
                }}
              >
                {item?.sub_menu?.length > 0 ? (
                  <div title={item?.title}>
                    <div
                      className={`flex items-center align-middle justify-between space-x-4 rtl:space-x-reverse border-l-4 border-l-white hover:border-l-4   py-2 px-4 
                    ${isMadhya
                          ? "hover:border-l-[#0C8A70]"
                          : isRajasthan
                            ? "hover:border-l-[#FFA51A]"
                            : isHR
                              ? "hover:border-l-[#EFF8EC]"
                              : isBH
                                ? "hover:border-l-[#f181c6]"
                                : isUP
                                  ? "hover:border-l-[#feedeb]"
                                  : isDL
                                    ? "hover:border-l-[#fbd6d6]"
                                    : isCGH
                                      ? "hover:border-l-[#0C8A70]"
                                      : isUK
                                        ? "hover:border-l-[#05a1fa]"
                                        : isBiz ? "hover:border-l-bizDark"
                                          : isPB ? "hover:border-l-pbDark"
                                            : "hover:border-l-primary"
                        }`}
                    >
                      <p
                        onClick={() => {
                          let eventName = `HamburgerMenu - ${item?.title} Click`;
                          sendGAEvent({
                            eventName: eventName,
                            pageTitle: document?.title,
                            pageLocation: window?.location?.href,
                          });
                          setIsDrawerOpen(false);
                        }}
                        className={`text-lg font-bold truncatetext-white  ${isMadhya
                          ? "hover:bg-[#e2f8f4] group"
                          : isRajasthan
                            ? "hover:bg-[#faf2e7] group"
                            : isHR
                              ? "hover:bg-[#e8fce1] group"
                              : isBH
                                ? "hover:bg-[#ffe2f4] group"
                                : isUP
                                  ? "hover:bg-[#feedeb] group"
                                  : isDL
                                    ? "hover:bg-[#fbd6d6] group"
                                    : isCGH
                                      ? "hover:bg-[#e0faf5] group"
                                      : isUK
                                        ? "hover:bg-[#e2f1fa] group"
                                        : isBiz ? "hover:bg-bizLight group"
                                          : isPB ? "hover:bg-pbLight group"
                                            : "hover:bg-primary-300 group"}`}
                        id={"dropdownHoverButton_" + index}
                        data-dropdown-toggle={"dropdownHover_" + index}
                      >
                        {item?.svg && (
                          <span className="w-4 h-4 inline-block mx-2">
                            <SVG className="w-4 h-4 inline" src={item?.svg} />
                          </span>
                        )}
                        <a href={websiteUrl + item?.canonical_url}>
                          {item?.title}
                        </a>
                      </p>
                      {item?.sub_menu?.length > 0 && (
                        <svg
                          className="w-2 h-2 ml-1"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 10 6"
                          onClick={() => setIsSubCategOpen(!IsSubCategOpen)}
                        >
                          <path
                            stroke="currentColor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="m1 1 4 4 4-4"
                          />
                        </svg>
                      )}
                    </div>
                  </div>
                ) : (
                  <a
                    onClick={() => {
                      let eventName = `HamburgerMenu - ${item?.title} Click`;
                      sendGAEvent({
                        eventName: eventName,
                        pageTitle: document?.title,
                        pageLocation: window?.location?.href,
                      });
                    }}
                    href={websiteUrl + item?.canonical_url}
                    title={item?.title}
                  >
                    <div className={`flex items-center align-middle justify-between space-x-4 rtl:space-x-reverse border-l-4 border-l-white hover:border-l-4   py-2 px-4 ${isMadhya
                      ? "hover:border-l-[#0C8A70]"
                      : isRajasthan
                        ? "hover:border-l-[#FFA51A]"
                        : isHR
                          ? "hover:border-l-[#EFF8EC]"
                          : isBH
                            ? "hover:border-l-[#f181c6]"
                            : isUP
                              ? "hover:border-l-[#feedeb]"
                              : isDL
                                ? "hover:border-l-[#fbd6d6]"
                                : isCGH
                                  ? "hover:border-l-[#0C8A70]"
                                  : isUK
                                    ? "hover:border-l-[#05a1fa]"
                                    : isBiz ? "hover:border-l-bizDark"
                                      : isPB ? "hover:border-l-pbDark"
                                        : "hover:border-l-primary"
                      }`}>
                      <p
                        onClick={() => setIsDrawerOpen(false)}
                        className={`text-lg font-bold truncatetext-white ${isMadhya
                          ? "hover:bg-[#e2f8f4]  "
                          : isRajasthan
                            ? "hover:bg-[#faf2e7]  "
                            : isHR
                              ? "hover:bg-[#e8fce1]  "
                              : isBH
                                ? "hover:bg-[#ffe2f4]  "
                                : isUP
                                  ? "hover:bg-[#feedeb]  "
                                  : isDL
                                    ? "hover:bg-[#fbd6d6]  "
                                    : isCGH
                                      ? "hover:bg-[#e0faf5]  "
                                      : isUK
                                        ? "hover:bg-[#e2f1fa]  "
                                        : isBiz ? "hover:bg-bizDark"
                                          : isPB ? "hover:bg-pbDark"
                                            : "hover:bg-primary-300  "} `}
                        id={"dropdownHoverButton_" + index}
                        data-dropdown-toggle={"dropdownHover_" + index}
                      >
                        {item?.svg && (
                          <span className="w-4 h-4 inline-block mx-2">
                            <SVG className="w-4 h-4 inline" src={item?.svg} />
                          </span>
                        )}
                        {item?.title}
                      </p>
                    </div>
                  </a>
                )}

                {/* Dropdown menu */}
                {item?.sub_menu?.length > 0 && IsSubCategOpen && (
                  <div
                    id={"dropdownHover_" + index}
                    className=" hidden w-full bg-white divide-y divide-gray-200 rounded-lg shadow-lg group-hover:block"
                  >
                    <ul
                      className="py-1 text-gray-700 dark:text-gray-200"
                      aria-labelledby={"dropdownHoverButton_" + index}
                    >
                      {item?.sub_menu?.map((sub_item, index2) => (
                        <li key={index2}>
                          <a
                            href={
                              websiteUrl +
                              (sub_item?.canonical_url
                                ? sub_item?.canonical_url.includes("www.")
                                  ? "https://www.mumbaitak.in"
                                  : sub_item?.canonical_url
                                : "")
                            }
                            onClick={() => {
                              let eventName = `HamburgerMenu - ${item?.title} - ${sub_item.title} Click`;
                              sendGAEvent({
                                eventName: eventName,
                                pageTitle: document?.title,
                                pageLocation: window?.location?.href,
                              });
                              setIsDrawerOpen(false);
                            }}
                            className={`block px-4 py-2 mx-2 font-medium ${isMadhya
                              ? "hover:bg-[#e2f8f4]  "
                              : isRajasthan
                                ? "hover:bg-[#faf2e7]  "
                                : isHR
                                  ? "hover:bg-[#e8fce1]  "
                                  : isBH
                                    ? "hover:bg-[#ffe2f4]  "
                                    : isUP
                                      ? "hover:bg-[#feedeb]  "
                                      : isDL
                                        ? "hover:bg-[#fbd6d6]  "
                                        : isCGH
                                          ? "hover:bg-[#e0faf5]  "
                                          : isUK
                                            ? "hover:bg-[#e2f1fa]  "
                                            : isBiz ? "hover:bg-bizLight"
                                              : isPB ? "hover:bg-pbLight"
                                                : "hover:bg-primary-300  "
                              }`}
                          >
                            {sub_item?.title}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </li>
            ))}
          </ul>
        </div>
      </section>
      {/* <style>
        {`
       .vdo_floating {
          bottom: 80px !important;
        }
        `}
      </style> */}
    </>
  );
};

export default MobileNavbar;
